
import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ApplicationApplicantService } from './application-applicant.service';

export const applicationResolver: ResolveFn<void> = async (activatedRoute: ActivatedRouteSnapshot) => {
  const queryParams = activatedRoute.params;

  return inject(ApplicationApplicantService).preparePortalApplication(
    queryParams.applicationId,
    queryParams.formId,
    queryParams.programId
  );
};

